(function() {
  'use strict';

  // Проверяем что конфиг попапа загружен
  if (!window.giftPopupConfig) {
    console.log('Gift popup disabled via metafields');
    return;
  }

  // DEBUG MODE: Set to true to disable all limits and force popup to show
  const DEBUG_MODE = false;

  // Flag to prevent cart form conflicts during popup operations
  let popupMakingChanges = false;

  // Проверка на checkout/thank you pages
  const currentPath = window.location.pathname;
  if (currentPath.includes('/checkout') || 
      currentPath.includes('/thank-you') ||
      currentPath.includes('/thank_you') ||
      currentPath.includes('/orders/') ||
      currentPath.includes('/account')) {
    console.log('GIFT WRAP POPUP disabled on checkout/account/thank you pages');
    return;
  }

  // Проверка на страницу Marsilia collection
  if (currentPath.includes('/pages/3-plus') || currentPath.includes('/pages/marsilia-collection')) {
    console.log('GIFT WRAP POPUP disabled on Marsilia collection page');
    return;
  }

  // Константы из конфига
  const config = window.giftPopupConfig;
  const delayMs = config.delay * 1000;
  const reshowDays = config.reshowDays;
  const reshowMs = reshowDays * 24 * 60 * 60 * 1000;

  // Проверяем localStorage
  const STORAGE_KEY = 'giftPopupState';
  const SESSION_KEY = 'giftPopupSession';
  const COOKIE_KEY = 'giftPopupShown';
  const popupState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  const sessionState = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
  const now = Date.now();

  // DEBUG MODE: Bypass all restrictions when DEBUG_MODE is true
  if (DEBUG_MODE) {
    console.log('DEBUG MODE: Bypassing all GIFT WRAP POPUP restrictions');
  } else {
    // Проверка использования опций
    if (popupState.giftOptionSelected) {
      console.log('GIFT WRAP POPUP disabled: option already selected');
      return;
    }

    // Проверка показа в текущей сессии (с cookie fallback)
    if (hasPopupBeenShownInSession()) {
      console.log('GIFT WRAP POPUP disabled: already shown in this session');
      return;
    }

    // Проверка повторного показа через N дней
    if (popupState.closed && popupState.closedAt) {
      const timeSinceClosed = now - popupState.closedAt;
      if (timeSinceClosed < reshowMs) {
        const daysLeft = Math.ceil((reshowMs - timeSinceClosed) / (24 * 60 * 60 * 1000));
        console.log(`GIFT WRAP POPUP will reshow in ${daysLeft} days`);
        return;
      }
    }
  }

  // DEBUG MODE: Reset session state to test popup
  if (DEBUG_MODE) {
    console.log('DEBUG MODE: Resetting session state to test popup');
    
    // Force complete reset by clearing both storage types
    sessionStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(STORAGE_KEY);
    
    // Set fresh clean state
    const newSessionState = {
      shownInSession: false,
      firstItemAdded: false
    };
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(newSessionState));
    
    const newPopupState = {
      shown: false,
      shownAt: 0,
      closed: false,
      giftOptionSelected: false
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newPopupState));
    
    console.log('DEBUG MODE: GIFT WRAP POPUP Complete state reset - popup should show on next cart addition');
    console.log('DEBUG MODE: GIFT WRAP POPUP Session state:', newSessionState);
    console.log('DEBUG MODE: GIFT WRAP POPUP state:', newPopupState);
  }

  // Cookie utility functions for fallback session tracking
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }

  function getCookie(name) {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  function deleteCookie(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
  }

  // Enhanced session state checking with cookie fallback
  function hasPopupBeenShownInSession() {
    // Check sessionStorage first (primary method)
    const sessionState = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    if (sessionState.shownInSession) {
      return true;
    }
    
    // Fallback to cookie if sessionStorage is not reliable
    const cookieValue = getCookie(COOKIE_KEY);
    if (cookieValue === 'true') {
      return true;
    }
    
    return false;
  }

  function markPopupShownInSession() {
    // Mark in sessionStorage
    const sessionState = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
    sessionState.shownInSession = true;
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(sessionState));
    
    // Also set cookie as fallback
    setCookie(COOKIE_KEY, 'true', 1); // Cookie expires in 1 day (session equivalent)
  }

  function resetPopupSessionState() {
    // Clear sessionStorage
    sessionStorage.removeItem(SESSION_KEY);
    
    // Clear cookie
    deleteCookie(COOKIE_KEY);
  }

  // Функция проверки наличия других активных попапов
  function hasActivePopups() {
    // Проверяем наличие других попапов (например, discount popup)
    const discountPopup = document.querySelector('.discount-popup, .promotion-popup, .modal');
    if (discountPopup && discountPopup.style.display === 'flex') {
      console.log('GIFT WRAP POPUP disabled: discount popup is active');
      return true;
    }
    
    // Проверяем наличие других модальных окон
    const modals = document.querySelectorAll('.modal, .popup, .overlay');
    for (let modal of modals) {
      if (modal.style.display === 'flex' || modal.style.display === 'block') {
        console.log('GIFT WRAP POPUP disabled: another modal is active');
        return true;
      }
    }
    
    return false;
  }

  // Функция показа попапа с проверкой других попапов
  function showPopupWithDelay() {
    // Проверяем есть ли активные попапы
    if (hasActivePopups()) {
      console.log('Waiting for other popups to close...');
      // Ждем 2 секунды и пробуем снова
      setTimeout(showPopupWithDelay, 2000);
      return;
    }
    
    // Показываем попап
    showPopup();
  }

  // Функция показа попапа после добавления товара в корзину
  function showPopupAfterCartAdd() {
    // Проверяем есть ли активные попапы
    if (hasActivePopups()) {
      console.log('Waiting for other popups to close...');
      // Ждем 2 секунды и пробуем снова
      setTimeout(showPopupAfterCartAdd, 2000);
      return;
    }
    
    // Показываем попап с задержкой
    setTimeout(showPopup, delayMs);
  }

  // Функция инициализации отслеживания добавления товаров в корзину
  function initCartTracking() {
    console.log('DEBUG: Initializing cart tracking...');
    
    // Отслеживаем fetch-based cart additions (для quick add и других fetch-методов)
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      const url = args[0];
      const options = args[1] || {};
      
      // Проверяем если это запрос к cart/add.js или cart/change.js
      if (typeof url === 'string' && (url.includes('/cart/add.js') || url.includes('/cart/change.js'))) {
        console.log('DEBUG: Fetch cart request detected:', url);
        
        // Проверяем тип запроса и данные, чтобы отличить добавление товара от изменения количества
        let isProductAddition = false;
        
        if (url.includes('/cart/add.js')) {
          // Это явно добавление товара
          isProductAddition = true;
          console.log('DEBUG: Detected product addition via cart/add.js');
        } else if (url.includes('/cart/change.js')) {
          // Это изменение количества, нужно проверить данные
          try {
            // Пытаемся получить данные запроса
            if (options.body && typeof options.body === 'string') {
              const formData = new URLSearchParams(options.body);
              const quantity = parseInt(formData.get('quantity') || '0');
              const id = formData.get('id');
              
              // Если количество > 0 и есть ID, это может быть добавление
              // Но если это изменение существующего товара, то не показываем попап
              if (quantity > 0 && id) {
                // Проверяем текущее состояние корзины, чтобы понять это добавление или изменение
                isProductAddition = checkIfNewProductAddition(id);
                console.log('DEBUG: Detected potential product addition via cart/change.js:', {
                  id, quantity, isProductAddition
                });
              }
            }
          } catch (e) {
            console.log('DEBUG: Could not parse cart change request data:', e);
          }
        }
        
        // Выполняем оригинальный fetch
        return originalFetch.apply(this, args).then(function(response) {
          // После успешного ответа, проверяем если это первое действие в сессии и это действительно добавление товара
          // Re-read session state to avoid race conditions
          const currentSessionState = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
          
          if (!currentSessionState.firstItemAdded && isProductAddition) {
            console.log('First fetch-based cart action detected (product addition only), preparing to show gift popup...');
            
            // Отмечаем что первое добавление произошло
            const newSessionState = {
              shownInSession: currentSessionState.shownInSession || false,
              firstItemAdded: true,
              firstItemAddedAt: Date.now()
            };
            sessionStorage.setItem(SESSION_KEY, JSON.stringify(newSessionState));
            
            // Показываем попап после задержки
            showPopupAfterCartAdd();
          } else if (isProductAddition) {
            console.log('Product addition detected but popup already shown in this session');
          } else {
            console.log('Cart change detected but not a new product addition (likely quantity change)');
          }
          
          return response;
        }).catch(function(error) {
          console.error('DEBUG: Fetch cart request failed:', error);
          throw error;
        });
      }
      
      // Для других запросов используем оригинальный fetch
      return originalFetch.apply(this, args);
    };

    // Также проверяем текущее состояние корзины при загрузке
    if (typeof theme !== 'undefined' && theme.cart) {
      console.log('DEBUG: Checking initial cart state...');
      theme.cart.getCart().then(function(cart) {
        console.log('DEBUG: Initial cart data:', cart);
        
        // theme.cart.getCart() returns a string, not JSON object
        let parsedCart;
        try {
          parsedCart = JSON.parse(cart);
          console.log('DEBUG: Parsed cart JSON:', parsedCart);
        } catch (e) {
          console.log('Cart data is not JSON, using as string:', cart);
          // If it's not JSON, assume cart has items if string is not empty
          if (cart && cart.length > 0 && !sessionState.firstItemAdded) {
            console.log('Cart has items on page load, preparing to show gift popup...');
            
            // Отмечаем что первое добавление произошло
            const newSessionState = {
              shownInSession: sessionState.shownInSession || false,
              firstItemAdded: true,
              firstItemAddedAt: Date.now()
            };
            sessionStorage.setItem(SESSION_KEY, JSON.stringify(newSessionState));
            
            // Показываем попап после задержки
            showPopupAfterCartAdd();
          }
          return;
        }
        
        // Re-read session state to avoid race conditions
        const currentSessionState = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
        
        if (parsedCart.item_count > 0 && !currentSessionState.firstItemAdded) {
          console.log('Cart has items on page load, preparing to show gift popup...');
          
          // Отмечаем что первое добавление произошло
          const newSessionState = {
            shownInSession: currentSessionState.shownInSession || false,
            firstItemAdded: true,
            firstItemAddedAt: Date.now()
          };
          sessionStorage.setItem(SESSION_KEY, JSON.stringify(newSessionState));
          
          // Показываем попап после задержки
          showPopupAfterCartAdd();
        } else {
          console.log('DEBUG: Initial cart check - no items or popup already shown', {
            item_count: parsedCart.item_count,
            firstItemAdded: currentSessionState.firstItemAdded
          });
        }
      }).catch(function(error) {
        console.error('DEBUG: Error getting initial cart:', error);
      });
    } else {
      console.log('DEBUG: Theme cart API not available');
    }
  }

  // Функция проверки, является ли изменение количества добавлением нового товара
  function checkIfNewProductAddition(productId) {
    // Получаем текущее состояние корзины
    if (typeof theme !== 'undefined' && theme.cart) {
      return theme.cart.getCart().then(function(cart) {
        try {
          const parsedCart = JSON.parse(cart);
          
          // Проверяем есть ли уже такой товар в корзине
          const existingItem = parsedCart.items.find(item => item.id.toString() === productId.toString());
          
          if (!existingItem) {
            // Товара нет в корзине, значит это новое добавление
            return true;
          } else {
            // Товар уже есть, это изменение количества существующего товара
            return false;
          }
        } catch (e) {
          // Если не удалось распарсить, предполагаем что это добавление
          console.log('DEBUG: Could not parse cart for product addition check:', e);
          return true;
        }
      }).catch(function(error) {
        console.error('DEBUG: Error checking cart for product addition:', error);
        // В случае ошибки предполагаем что это добавление
        return Promise.resolve(true);
      });
    } else {
      // Если API недоступно, предполагаем что это добавление
      return Promise.resolve(true);
    }
  }

  // Функция показа попапа
  function showPopup() {
    const popup = document.getElementById('gift-popup');
    if (!popup) {
      console.error('Gift popup element not found');
      return;
    }

    // Заполняем контент
    document.getElementById('gift-popup-title').textContent = config.title || 'Ambalăm cadoul tău – gratuit';
    document.getElementById('gift-popup-text').textContent = config.text || 'Vrei ca produsele tale să fie împachetate elegant, gata de oferit?';

    // Показываем попап
    popup.style.display = 'flex';
    
    // Only disable scroll if not on cart page to avoid conflicts
    if (!window.location.pathname.includes('/cart')) {
      document.body.style.overflow = 'hidden';
    }

    // Сохраняем что показали
    const newState = {
      shown: true,
      shownAt: now,
      closed: false
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));

    // Отмечаем что показали в текущей сессии (с cookie fallback)
    markPopupShownInSession();

    console.log('Gift popup shown');
  }

  // Функция закрытия попапа (только закрытие, без выбора опций)
  function closePopup() {
    const popup = document.getElementById('gift-popup');
    popup.style.display = 'none';
    document.body.style.overflow = '';

    // Сохраняем что закрыли, но НЕ устанавливаем giftOptionSelected = true
    // Это позволяет пользователю снова увидеть попап в будущем
    const currentState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    currentState.closed = true;
    currentState.closedAt = Date.now();
    // Удаляем giftOptionSelected чтобы не блокировать будущие показы
    delete currentState.giftOptionSelected;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(currentState));

    console.log(`Gift popup closed. Will reshow in ${reshowDays} days.`);
  }

  // Функция выбора "Да, te rog"
  function selectYes() {
    closePopup();
    
    // Сохраняем что выбрали опцию
    const currentState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    currentState.giftOptionSelected = true;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(currentState));

    // Автоматически выбираем первую опцию (gift wrapping)
    selectFirstGiftOption();
    console.log('Gift wrapping option selected via popup');
  }

  // Функция выбора "Nu, mulțumesc"
  function selectNo() {
    // Сохраняем что отказались
    const currentState = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    currentState.giftOptionSelected = true; // Чтобы не показывать больше
    localStorage.setItem(STORAGE_KEY, JSON.stringify(currentState));

    // Select the hidden "no gift wrapping" radio button instead of clearing attributes
    selectNoGiftWrappingOption();

    // Hide holiday packages immediately
    hideHolidayPackagesImmediately();

    // Close the popup
    closePopup();

    console.log('No gift wrapping option selected via popup');
  }

  // Функция выбора первой опции (gift wrapping)
  function selectFirstGiftOption() {
    console.log('Selecting first gift option (gift wrapping)...');

    // Set flag to prevent cart form conflicts - keep it set longer
    popupMakingChanges = true;

    // Используем API корзины для обновления атрибута
    if (typeof theme !== 'undefined' && theme.cart && theme.cart.updateAttribute) {
      const value = 'gift_wrapping';

      // Сначала обновляем визуальное состояние радио кнопки
      // Пытаемся найти по ID (gift-wrapping-radio) или по name и value
      let giftRadio = document.getElementById('gift-wrapping-radio') ||
                      document.querySelector('input[name="attributes[gift_option]"][value="gift_wrapping"]');

      if (giftRadio) {
        giftRadio.checked = true;
        console.log('Gift wrapping radio button found and checked immediately');
      } else {
        console.log('Gift wrapping radio button not found initially, will check after cart update');
      }

      // Затем обновляем атрибут корзины
      theme.cart.updateAttribute('gift_option', value)
        .then(function() {
          console.log('Gift wrapping option set via cart API');

          // После обновления атрибута корзина перестроится сама
          // Проверяем и обновляем состояние радио кнопки после перестройки
          setTimeout(function() {
            // Try multiple selectors to find the radio button
            let giftRadio = document.getElementById('gift-wrapping-radio') ||
                           document.querySelector('input[name="attributes[gift_option]"][value="gift_wrapping"]') ||
                           document.querySelector('.cart__gift-option-input[value="gift_wrapping"]');

            if (giftRadio && !giftRadio.checked) {
              giftRadio.checked = true;
              console.log('Gift wrapping radio button checked after cart rebuild');

              // Имитируем изменение для обновления корзины - but don't trigger cart form
              // const event = new Event('change', { bubbles: true });
              // giftRadio.dispatchEvent(event);
            } else {
              console.log('Gift wrapping radio button already checked or not found after cart rebuild');
            }

            // Clear flag after a longer delay to ensure all operations complete
            setTimeout(function() {
              popupMakingChanges = false;
              console.log('Popup making changes flag cleared');
            }, 500);
          }, 300); // Increased delay for cart rebuild
        })
        .catch(function(error) {
          console.warn('Gift option update failed, using fallback:', error);

          // Fallback: try to find and check the radio button directly
          let giftRadio = document.getElementById('gift-wrapping-radio') ||
                         document.querySelector('input[name="attributes[gift_option]"][value="gift_wrapping"]') ||
                         document.querySelector('.cart__gift-option-input[value="gift_wrapping"]');

          if (giftRadio) {
            giftRadio.checked = true;
            console.log('Gift wrapping radio button checked via fallback');

            // Don't trigger change event in fallback to avoid conflicts
            // const event = new Event('change', { bubbles: true });
            // giftRadio.dispatchEvent(event);
          } else {
            console.log('Gift wrapping radio button not found in fallback');
          }

          // Clear flag after operation completes
          setTimeout(function() {
            popupMakingChanges = false;
            console.log('Popup making changes flag cleared (fallback)');
          }, 500);
        });
    } else {
      console.log('Cart API not available, trying direct update...');

      // Fallback: try to find and check the radio button directly
      let giftRadio = document.getElementById('gift-wrapping-radio') ||
                     document.querySelector('input[name="attributes[gift_option]"][value="gift_wrapping"]');

      if (giftRadio) {
        giftRadio.checked = true;
        console.log('Gift wrapping radio button checked via direct update');

        // Don't trigger change event to avoid conflicts
        // const event = new Event('change', { bubbles: true });
        // giftRadio.dispatchEvent(event);
      } else {
        console.log('Gift wrapping radio button not found, trying with observer...');

        // Если радио кнопка не найдена, ждем ее появления
        waitForGiftRadio().then(function(radio) {
          if (radio) {
            radio.checked = true;
            console.log('Gift wrapping radio button checked via observer');

            // Don't trigger change event to avoid conflicts
            // const event = new Event('change', { bubbles: true });
            // radio.dispatchEvent(event);
          }
        });
      }

      // Clear flag after operation completes
      setTimeout(function() {
        popupMakingChanges = false;
        console.log('Popup making changes flag cleared (direct)');
      }, 500);
    }
  }

  // Функция выбора опции "no gift wrapping" (скрытая радио кнопка)
  function selectNoGiftWrappingOption() {
    console.log('Selecting no gift wrapping option...');

    // Set flag to prevent cart form conflicts - keep it set longer
    popupMakingChanges = true;

    // Используем API корзины для обновления атрибута
    if (typeof theme !== 'undefined' && theme.cart && theme.cart.updateAttribute) {
      const value = 'no_gift_wrapping';

      // Сначала обновляем визуальное состояние скрытой радио кнопки
      const noGiftRadio = document.querySelector('input[name="attributes[gift_option]"][value="no_gift_wrapping"]');
      if (noGiftRadio) {
        noGiftRadio.checked = true;
        console.log('No gift wrapping radio button checked');
      }

      // Затем обновляем атрибут корзины
      theme.cart.updateAttribute('gift_option', value)
        .then(function() {
          console.log('No gift wrapping option selected via cart API');

          // После обновления атрибута корзина перестроится сама
          // Проверяем и обновляем состояние радио кнопки после перестройки
          setTimeout(function() {
            const noGiftRadio = document.querySelector('input[name="attributes[gift_option]"][value="no_gift_wrapping"]');
            if (noGiftRadio && !noGiftRadio.checked) {
              noGiftRadio.checked = true;
              console.log('No gift wrapping radio button checked after cart rebuild');

              // Don't trigger change event to avoid conflicts
              // const event = new Event('change', { bubbles: true });
              // noGiftRadio.dispatchEvent(event);
            } else {
              console.log('No gift wrapping radio button already checked or not found after cart rebuild');
            }

            // Clear flag after a longer delay to ensure all operations complete
            setTimeout(function() {
              popupMakingChanges = false;
              console.log('Popup making changes flag cleared (no gift wrapping)');
            }, 500);
          }, 300); // Increased delay for cart rebuild
        })
        .catch(function(error) {
          console.warn('No gift wrapping option update failed, using fallback:', error);

          // Fallback: пробуем обновить напрямую
          const noGiftRadio = document.querySelector('input[name="attributes[gift_option]"][value="no_gift_wrapping"]');
          if (noGiftRadio) {
            noGiftRadio.checked = true;
            console.log('No gift wrapping radio button checked via fallback');

            // Don't trigger change event to avoid conflicts
            // const event = new Event('change', { bubbles: true });
            // noGiftRadio.dispatchEvent(event);
          }

          // Clear flag after operation completes
          setTimeout(function() {
            popupMakingChanges = false;
            console.log('Popup making changes flag cleared (fallback no gift wrapping)');
          }, 500);
        });
    } else {
      console.log('Cart API not available, trying direct update...');

      // Fallback: пробуем обновить напрямую
      const noGiftRadio = document.querySelector('input[name="attributes[gift_option]"][value="no_gift_wrapping"]');
      if (noGiftRadio) {
        noGiftRadio.checked = true;
        console.log('No gift wrapping radio button checked via direct update');

        // Don't trigger change event to avoid conflicts
        // const event = new Event('change', { bubbles: true });
        // noGiftRadio.dispatchEvent(event);
      }

      // Clear flag after operation completes
      setTimeout(function() {
        popupMakingChanges = false;
        console.log('Popup making changes flag cleared (direct no gift wrapping)');
      }, 500);
    }
  }



  // Функция скрытия секции holiday packages с анимацией
  function hideHolidayPackages() {
    const holidayPackages = document.querySelector('.cart__holiday-packages');
    if (holidayPackages) {
      // Добавляем класс для анимации скрытия
      holidayPackages.classList.add('cart__holiday-packages--hidden');

      // Скрываем элемент через 300мс (длительность анимации)
      setTimeout(function() {
        holidayPackages.style.display = 'none';
        // Удаляем класс анимации чтобы можно было показать снова
        holidayPackages.classList.remove('cart__holiday-packages--hidden');
      }, 300);

      console.log('Holiday packages section hidden with animation');
    }
  }

  // Функция немедленного скрытия секции holiday packages (без анимации)
  function hideHolidayPackagesImmediately() {
    const holidayPackages = document.querySelector('.cart__holiday-packages');
    if (holidayPackages) {
      // Немедленно скрываем элемент без анимации
      holidayPackages.style.display = 'none';
      // Удаляем класс анимации если он был добавлен
      holidayPackages.classList.remove('cart__holiday-packages--hidden');

      console.log('Holiday packages section hidden immediately');
    }
  }



  // Функция ожидания появления радио кнопки подарочной упаковки
  function waitForGiftRadio() {
    return new Promise(function(resolve) {
      const radio = document.querySelector('input[name="attributes[gift_option]"][value="gift_wrapping"]');
      if (radio) {
        resolve(radio);
        return;
      }

      // Используем MutationObserver для отслеживания появления радио кнопки
      const observer = new MutationObserver(function(mutations) {
        const radio = document.querySelector('input[name="attributes[gift_option]"][value="gift_wrapping"]');
        if (radio) {
          observer.disconnect();
          resolve(radio);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Таймаут на случай, если радио кнопка так и не появится
      setTimeout(function() {
        observer.disconnect();
        resolve(null);
      }, 5000);
    });
  }

  // Инициализация после загрузки DOM
  function init() {
    // Добавляем обработчики событий
    const closeBtn = document.querySelector('.gift-popup__close');
    const overlay = document.querySelector('.gift-popup__overlay');
    const yesBtn = document.getElementById('gift-popup-yes');
    const noBtn = document.getElementById('gift-popup-no');

    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);
    if (yesBtn) yesBtn.addEventListener('click', selectYes);
    if (noBtn) noBtn.addEventListener('click', selectNo);

    // ESC закрывает попап
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const popup = document.getElementById('gift-popup');
        if (popup && popup.style.display === 'flex') {
          closePopup();
        }
      }
    });

    // Инициализируем отслеживание добавления товаров в корзину
    initCartTracking();
  }

  // Запуск после загрузки DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
